import { registerPermissionDirective } from './permission'

export default {
  install(app) {
    registerPermissionDirective(app)
  },
} 